import { createAction } from 'redux-actions';
import { RESET, SET_ALL_GROUPS, SET_TOTAL, SET_LOADING } from './actionTypes';
import { getGroups } from './service';
import STATUS_CODE from '../../../request/statusCode';

const setAllGroups = createAction(SET_ALL_GROUPS);

const setTotal = createAction(SET_TOTAL);

const setLoading = createAction(SET_LOADING);

const reset = createAction(RESET);

const getAllGroups = ({ page, size, keyword, privilegedOnly }) => {
  return dispatch => {
    dispatch(setLoading(true));
    return getGroups({ page, size, keyword, privilegedOnly }).then(res => {
      dispatch(setLoading(false));
      if (res.statusCode === STATUS_CODE.OK) {
        const { content, totalElements } = res.data;
        dispatch(setAllGroups(content));
        dispatch(setTotal(totalElements));
      } else {
        dispatch(setAllGroups([]));
        dispatch(setTotal(0));
      }
    });
  };
};

export { getAllGroups, setAllGroups, setTotal, reset, setLoading };
